<template>
  <AuthLayout :mode="mode">
    <Section
      heading="PowerSearch"
      description="Search for equipment in our database using keywords. <br class='sm:hidden' /> You can also filter by how recent the listings are and save your <br class='sm:hidden' /> search for future use."
      :mode="mode"
    />
    <SearchForm :mode="mode" />
  </AuthLayout>
</template>

<script>
import Section from "@C/Common/Section.vue";
import SearchForm from "@C/SearchForm.vue";
import AuthLayout from "@A/AuthLayout.vue";

export default {
  name: "Search",
  components: {
    AuthLayout,
    Section,
    SearchForm,
  },
  props: {
    mode: String,
  },
};
</script>
